import axios from 'axios';

import apiConstants from './constants/api-constants';
import Helpers from '../common/helpers';

class PaymentsApi {
  static getUserBalance() {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.payment_routes.get_user_balance);

    return axios(request);
  }

  static requestWithdrawal(amount, description, payment_method_id, currency) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.payment_routes.request_withdrawal, { amount, description, payment_method_id, currency });

    return axios(request);
  }

  static getPaymentHistory(statuses) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.payment_routes.get_payment_history, null, null, {
      statuses,
    });

    return axios(request);
  }

  static getUserPaymentMethods(status, provider, type) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.payment_routes.get_user_payment_methods, null, { status, provider, type });

    return axios(request);
  }

  static getPaymentMethodTypes(active) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.payment_routes.get_payment_method_types, null, { active });

    return axios(request);
  }

  static saveUserPaymentMethod(data) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.payment_routes.save_user_payment_method, data);

    return axios(request);
  }

  static getRate(symbol) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.payment_routes.get_rate, null, { symbol });

    return axios(request);
  }
}

export default PaymentsApi;



// WEBPACK FOOTER //
// ./src/api/payments-api.js